import { css } from 'styled-components'

const sizes = {
  small: 0,
  medium: 768,
  large: 1000,
  xmlarge: 1280,
  xxlarge: 1440,
}

// Iterate through the sizes and create a media template
export const minmedia = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media screen and (min-width: ${sizes[label]}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

// Iterate through the sizes and create a media template
export const maxmedia = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media screen and (max-width: ${sizes[label] - 1}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

/*
${minmedia.xmlarge`
  width: 25%;
`}

equals:

@media screen and (min-width: 1280px) {
  width: 25%;
}
*/



// WEBPACK FOOTER //
// ./src/styles/media-queries.js